import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.RowStrip = class RowStrip extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-row-strip';
	}

	constructor(element) {
		super(element);

		this.backgroundImage = new Image();
	}

	render() {
		this.setVars();
		this.setStripDisplayRules();
		this.setEventListeners();
	}

	setVars() {
		this.options = {
			images: {
				small: this.$element.data('smallImage'),
				large: this.$element.data('largeImage')
			},
            backgroundColor: this.$element.data('backgroundColor')
		};
	}

	setEventListeners() {
        window.addEventListener('fa.viewportResize', this.setRelevantBackground.bind(this));
        document.addEventListener("DOMContentLoaded", this.changeTitleColor());
	}

	setStripDisplayRules() {
		if (this.options.images.small && this.options.images.large) {
			this.setRelevantBackground();
		} else {
			this.setStripColor();
		}
	}

	setRelevantBackground() {

		/**
		* This functionality has a bug which results in the '--loaded' class not being added to elements with class '.fa-row-strip'.
		* This bug causes many components tobe left hidden on mobile
		*
		* The CSS transition for the 'fa-row-strip' class has been temporarily disabled until a fix can be found
		*/

		this.imageToRequest = window.globalConfigs.viewportIsBelowLarge ? this.options.images.small : this.options.images.large;

		if (this.imageToRequest !== this.cachedImagePath) {
			this.backgroundImage.src = this.imageToRequest;
			this.backgroundImage.onload = this.onImageLoadedSuccess.bind(this);
			this.backgroundImage.onerror = this.fallbackToDefault.bind(this);

			this.cachedImagePath = this.imageToRequest;
		}
	}

	onImageLoadedSuccess() {
		this.$element.css({
			backgroundImage: `url(${this.imageToRequest})`
		});

		this.setStripReady();
	}

	fallbackToDefault() {
		this.setStripReady();
	}

	setStripReady() {
		this.$element.addClass('fa-row-strip--loaded');
	}

	setStripColor() {
		const backgroundColor = this.options.backgroundColor;

		if (backgroundColor) {
			this.$element.css({
				backgroundColor: backgroundColor
			});
		}

		this.setStripReady();
    }

    changeTitleColor() {
        if (this.options.backgroundColor && document.body.classList.contains('ws-theme')) {
            let links = this.$element.find('.fa-row-heading__link') ? this.$element.find('.fa-row-heading__link') : null;
            console.log("link", links)
            if (this.lightOrDark(this.options.backgroundColor) === 'light') {
                this.$element.find('.fa-row-heading__title').css('color', '#011e41')
                this.$element.find('.fa-row-heading__intro ').css('color', '#011e41')
                this.$element.find('.fa-row-heading__title span').css('fill', '#011e41')

                if (links) {
                    this.$element.find('.fa-row-heading__link').css('color', '#011e41');
                    links.map((i, link) => {
                        link.addEventListener('mouseover', (e) => {
                            console.log(e.currentTarget);
                            e.currentTarget.style.color = '#007b85';
                            this.$element.find('.fa-row-heading__title .icon').css('color', '#007b85')
                        })

                        link.addEventListener('mouseleave', (e) => {
                            e.currentTarget.style.color = '#011e41';
                            this.$element.find('.fa-row-heading__title .icon').css('color', '#011e41')
                        })

                    })
                }
                
            } else {
                this.$element.find('.fa-row-heading__title').css('color', '#fff')
                this.$element.find('.fa-row-heading__title span').css('fill', '#fff')
                this.$element.find('.fa-row-heading__intro').css('color', '#fff')

                if (links) {
                    this.$element.find('.fa-row-heading__link').css('color', '#fff')
                    links.map((i, link) => {
                        link.addEventListener('mouseover', (e) => {
                            e.currentTarget.style.color = '#3bffcc';
                            this.$element.find('.fa-row-heading__title .icon').css('color', '#3bffcc')
                        })

                        link.addEventListener('mouseleave', (e) => {
                            e.currentTarget.style.color = '#fff';
                            this.$element.find('.fa-row-heading__title .icon').css('color', '#fff')
                        })
                    })
                }
                

            }
        }
    }

    lightOrDark(color) {
        var r, g, b, hsp;
        if (this.options.backgroundColor && document.body.classList.contains('ws-theme')) {
            if (color.match(/^rgb/)) {

                color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

                r = color[1];
                g = color[2];
                b = color[3];
            }
            else {
                color = +("0x" + color.slice(1).replace(
                    color.length < 5 && /./g, '$&$&'));

                r = color >> 16;
                g = color >> 8 & 255;
                b = color & 255;
            }

            // HSP equation from http://alienryderflex.com/hsp.html
            hsp = Math.sqrt(
                0.299 * (r * r) +
                0.587 * (g * g) +
                0.114 * (b * b)
            );

            if (hsp > 140.5) {

                return 'light';
            }
            else {

                return 'dark';
            }
        }
    }
};



// WEBPACK FOOTER //
// ./components/rowStrip/scripts/rowStrip.js